module.exports = __webpack_public_path__ + "static/media/publix.ac2d03be.png";